/**
 * Vencimiento de las cachés offline (réplica de tablas + snapshot del app-shell).
 *
 * Los datos offline sobreviven a la recarga, pero NO indefinidamente: pasado este
 * tiempo se consideran vencidos, se ignoran al leer y se purgan del disco. Es una
 * medida de seguridad — datos de negocio y contexto/permisos no deben quedar
 * cacheados para siempre en el dispositivo.
 *
 * Ajustable en un solo lugar. 24 h es el default (equilibrio entre utilidad
 * offline y frescura/seguridad).
 */
export const OFFLINE_CACHE_TTL_MS = 24 * 60 * 60 * 1000; // 24 horas

/** true si `savedAt` (epoch ms) ya venció según el TTL. */
export function isOfflineCacheExpired(
  savedAt: number | undefined,
  ttlMs: number = OFFLINE_CACHE_TTL_MS,
): boolean {
  if (!savedAt || typeof savedAt !== "number") return true;
  return Date.now() - savedAt > ttlMs;
}
